import api from 'services/api/microfwk';
import _ from 'lodash';
import { apiCall } from 'api';
import { PAYWAY_V1_LINEALCHANNELS_PATH_SERVICE } from 'api/services/content/paths';
import { getUserIsLoggendin } from 'containers/User/service';
import { getUserToken } from 'utils/user/getUserToken';

export const paywayLinealChannels = async (params = {}) => {
  if (!getUserToken()) {
    await getUserIsLoggendin();
  }
  
  apiCall.defaults.headers['user-token'] = `Bearer ${getUserToken()}`;

  return apiCall
    .get(PAYWAY_V1_LINEALCHANNELS_PATH_SERVICE, {
      params: { ...params, user_token: null, HKS: null },
    })
    .then(({ data }) => {
      return data;
    })
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
};
